import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

const ReconsignmentBanner = () => (
  <Box
    alignItems="center"
    bgcolor="success.light" // this is a success color should be added to theme as lighter
    border="none"
    borderRadius="4px"
    display="flex"
    justifyContent="space-between"
    sx={{
      borderRadius: 0.5,
      mt: 2,
      p: 2,
    }}
    width="100%"
  >
    <InfoRoundedIcon sx={{ color: 'graphic.main' }} />
    <Typography
      sx={{
        pl: '18px',
        pr: 2,
        py: 0,
      }}
      variant="body2"
    >
      Reconsignment is a fee based service. Please review your Data Services Agreement for questions
      on fees.
    </Typography>
  </Box>
);

export default ReconsignmentBanner;
